<template>
  <div class="relative">
    <!-- Phone icon button (matches the nav drawer buttons) -->
    <Button
      class="rounded-full p-2 hover:!bg-gray-200 text-black"
      @click="toggleDialer"
    >
      <v-icon>mdi-phone</v-icon>
    </Button>

    <!-- Dialpad popover -->
    <transition
      enter-active-class="transition-opacity duration-300 ease-in-out"
      enter-from-class="opacity-0"
      enter-to-class="opacity-100"
      leave-active-class="transition-opacity duration-300 ease-in-out"
      leave-from-class="opacity-100"
      leave-to-class="opacity-0"
    >
      <div
        v-show="showDialer"
        class="fixed bottom-0 mb-4 mx-4 w-72 bg-primary-900 rounded-xl shadow-lg p-4 z-50"
        :class="currentLocal == 'ar' ? 'left-0' : 'right-0'"
        style="direction: ltr"
      >
        <button
          class="absolute top-2 left-2 text-white text-xs p-1 border-solid border-white border-2 rounded-full m-1"
          @click="toggleDialer"
        >
          <v-icon>mdi-close</v-icon>
        </button>
        <input
          ref="phoneInput"
          v-model="phoneNumber"
          type="text"
          class="w-full p-2 rounded text-center text-xl text-white bg-transparent focus:outline-none focus:ring-0 focus:border-0"
          placeholder="Enter number"
          @input="validateInput"
          @keyup.enter="makeCall"
        />
        <div class="grid grid-cols-3 px-8">
          <button
            v-for="(number, index) in dialpadNumbers"
            :key="index"
            class="p-2 m-2 border rounded-full bg-coal-blue text-lg text-white"
            @click="appendNumber(number)"
          >
            {{ number }}
          </button>
        </div>
        <div class="mt-4 flex justify-center">
          <button
            class="bg-green-500 text-white p-4 rounded-full hover:bg-green-600"
            @click="makeCall"
          >
            <v-icon>mdi-phone</v-icon>
          </button>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import { Button } from "primevue";

export default {
  components: {
    Button,
  },
  data() {
    return {
      showDialer: false,
      phoneNumber: "",
      dialpadNumbers: [
        "1",
        "2",
        "3",
        "4",
        "5",
        "6",
        "7",
        "8",
        "9",
        "*",
        "0",
        "#",
      ],
    };
  },
  computed: {
    currentLocal() {
      return this.$vuetify.locale.current;
    },
  },
  methods: {
    ...mapMutations(["setNumberToCall"]),
    toggleDialer() {
      this.showDialer = !this.showDialer;
      if (this.showDialer) {
        this.$nextTick(() => {
          this.$refs.phoneInput.focus();
        });
      }
    },
    validateInput(event) {
      // Only allow numbers, *, and #
      this.phoneNumber = event.target.value.replace(/[^0-9*#]/g, "");
    },
    appendNumber(number) {
      this.phoneNumber += number;
      this.$nextTick(() => {
        this.$refs.phoneInput.focus();
      });
    },
    clearNumber() {
      this.phoneNumber = this.phoneNumber.slice(0, -1);
      this.$nextTick(() => {
        this.$refs.phoneInput.focus();
      });
    },
    makeCall() {
      if (this.phoneNumber) {
        // Trigger the call through the shared store state; WebPhone watches
        // numberToCall and places the call (keeps the dialer decoupled so it
        // can live in the nav drawer).
        this.setNumberToCall(this.phoneNumber);
        this.phoneNumber = "";
        this.showDialer = false;
      }
    },
  },
};
</script>

<style scoped></style>
